/*******************************************************************************
 * rerun-report.js - Re-run Report Feature
 ******************************************************************************/

const { ELEMENT_IDS, API_ENDPOINTS } = window;
const { getElement, showElement, hideElement, showDialog, hideDialog } = window;
const { logToServer } = window;

const reRunReport = {
    selectedContacts: [],
    invoiceGroups: [],

    /**
     * Opens the re-run report modal dialog
     * Resets all state and prepares the UI for a new search
     */
    openModal: function() {
        try {
            var dialogElement = getElement(ELEMENT_IDS.RERUN_DIALOG);
            
            if (!dialogElement) {
                logToServer("error", "Re-run report dialog element not found", {});
                alert("Dialog not found. Please refresh the page.");
                return;
            }
            
            if (!dialogElement.ej2_instances || !dialogElement.ej2_instances[0]) {
                logToServer("error", "Re-run report dialog not initialized", {});
                alert("Dialog not ready. Please wait a moment and try again.");
                return;
            }
            
            var dialog = dialogElement.ej2_instances[0];
            showDialog(ELEMENT_IDS.RERUN_DLG_CONTAINER);
            
            // Reset state
            this.selectedContacts = [];
            this.invoiceGroups = [];
            document.getElementById("reRunResultsContainer").style.display = "none";
            document.getElementById("reRunNoResults").style.display = "none";
            document.getElementById("reRunLoadingIndicator").style.display = "none";
            document.getElementById("reRunProgressContainer").style.display = "none";
            document.getElementById("reRunDownloadContainer").style.display = "none";
            document.getElementById("btnReRunReportGenerate").disabled = true;
            document.getElementById("reRunSelectAll").checked = false;
            this.updateSelectedCount();
            
            dialog.show();
            
            // Set up button handlers (inside try block so dialog is in scope)
            document.getElementById("btnReRunReportCancel").onclick = function() {
                dialog.hide();
            };
            
            document.getElementById("btnReRunReportGenerate").onclick = function() {
                reRunReport.generateReport();
            };
        } catch (e) {
            console.error("Error opening Re-run Report modal:", e);
            alert("Error opening dialog: " + e.message);
        }
    },

    search: function() {
        console.log("Re-run report search started");
        var startDatePicker = document.getElementById("reRunStartDate").ej2_instances[0];
        var endDatePicker = document.getElementById("reRunEndDate").ej2_instances[0];
        
        var startDate = startDatePicker.value;
        var endDate = endDatePicker.value;
        
        console.log("Start date:", startDate, "End date:", endDate);
        
        if (!startDate || !endDate) {
            alert("Please select both start and end dates");
            return;
        }
        
        // Show loading
        document.getElementById("reRunLoadingIndicator").style.display = "block";
        document.getElementById("reRunResultsContainer").style.display = "none";
        document.getElementById("reRunNoResults").style.display = "none";
        document.getElementById("reRunProgressContainer").style.display = "none";
        document.getElementById("reRunDownloadContainer").style.display = "none";
        
        var requestData = {
            StartDate: startDate.toISOString(),
            EndDate: endDate.toISOString(),
            Page: 1,
            PageSize: 100
        };
        
        console.log("Sending request:", JSON.stringify(requestData));
        
        $.ajax({
            url: API_ENDPOINTS.GET_PAID_INVOICES,
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(requestData),
            success: function(response) {
                console.log("Response received:", response);
                document.getElementById("reRunLoadingIndicator").style.display = "none";
                
                if (response.isError) {
                    alert("Error: " + response.errorMessage);
                    return;
                }
                
                reRunReport.invoiceGroups = response.groups || [];
                reRunReport.selectedContacts = [];
                
                console.log("Invoice groups:", reRunReport.invoiceGroups.length);
                
                if (reRunReport.invoiceGroups.length === 0) {
                    document.getElementById("reRunNoResults").style.display = "block";
                } else {
                    reRunReport.renderResults();
                    document.getElementById("reRunResultsContainer").style.display = "block";
                }
                
                reRunReport.updateSelectedCount();
                document.getElementById("reRunSelectAll").checked = false;
            },
            error: function(xhr, status, error) {
                console.error("Error fetching paid invoices:", status, error, xhr.responseText);
                document.getElementById("reRunLoadingIndicator").style.display = "none";
                alert("Failed to fetch paid invoices: " + error);
            }
        });
    },

    renderResults: function() {
        var container = document.getElementById("reRunInvoicesList");
        var html = '';
        
        this.invoiceGroups.forEach(function(group, index) {
            var invoiceCount = group.invoices ? group.invoices.length : 0;
            var totalFormatted = group.totalAmount ? group.totalAmount.toFixed(2) : '0.00';
            
            html += '<div class="rerun-contact-group" style="border-bottom: 1px solid #eee; padding: 10px;">';
            html += '  <div style="display: flex; align-items: center;">';
            html += '    <input type="checkbox" class="rerun-contact-checkbox" data-contact-id="' + group.contactId + '" ';
            html += '           onchange="reRunReport.toggleContact(\'' + group.contactId + '\')" style="margin-right: 10px;">';
            html += '    <div style="flex: 1;">';
            html += '      <strong>' + (group.contactName || 'Unknown') + '</strong>';
            html += '      <span style="color: #666; margin-left: 10px;">(' + invoiceCount + ' invoice' + (invoiceCount !== 1 ? 's' : '') + ')</span>';
            html += '    </div>';
            html += '    <div style="text-align: right;">';
            html += '      <strong>$' + totalFormatted + '</strong>';
            html += '    </div>';
            html += '  </div>';
            
            if (group.contactEmail) {
                html += '  <div style="margin-left: 25px; color: #666; font-size: 12px;">' + group.contactEmail + '</div>';
            }
            
            // Show invoice details
            if (group.invoices && group.invoices.length > 0) {
                html += '  <div style="margin-left: 25px; margin-top: 5px; font-size: 12px; color: #888;">';
                group.invoices.slice(0, 3).forEach(function(inv) {
                    var paymentDate = inv.paymentDate ? new Date(inv.paymentDate).toLocaleDateString() : 'N/A';
                    html += '<span style="margin-right: 15px;">' + (inv.invoiceNumber || 'N/A') + ' - $' + (inv.amountPaid || 0).toFixed(2) + ' (' + paymentDate + ')</span>';
                });
                if (group.invoices.length > 3) {
                    html += '<span>...and ' + (group.invoices.length - 3) + ' more</span>';
                }
                html += '  </div>';
            }
            
            html += '</div>';
        });
        
        container.innerHTML = html;
    },

    toggleContact: function(contactId) {
        var index = this.selectedContacts.indexOf(contactId);
        if (index === -1) {
            this.selectedContacts.push(contactId);
        } else {
            this.selectedContacts.splice(index, 1);
        }
        this.updateSelectedCount();
        this.updateSelectAllCheckbox();
    },

    toggleSelectAll: function() {
        var selectAllChecked = document.getElementById("reRunSelectAll").checked;
        var checkboxes = document.querySelectorAll(".rerun-contact-checkbox");
        
        this.selectedContacts = [];
        
        if (selectAllChecked) {
            this.invoiceGroups.forEach(function(group) {
                reRunReport.selectedContacts.push(group.contactId);
            });
        }
        
        checkboxes.forEach(function(cb) {
            cb.checked = selectAllChecked;
        });
        
        this.updateSelectedCount();
    },

    updateSelectAllCheckbox: function() {
        var selectAll = document.getElementById("reRunSelectAll");
        selectAll.checked = this.selectedContacts.length === this.invoiceGroups.length && this.invoiceGroups.length > 0;
    },

    updateSelectedCount: function() {
        var count = this.selectedContacts.length;
        document.getElementById("reRunSelectedCount").textContent = count + " contact" + (count !== 1 ? "s" : "") + " selected";
        document.getElementById("btnReRunReportGenerate").disabled = count === 0;
    },

    generateReport: function() {
        if (this.selectedContacts.length === 0) {
            alert("Please select at least one contact");
            return;
        }
        
        var startDatePicker = document.getElementById("reRunStartDate").ej2_instances[0];
        var endDatePicker = document.getElementById("reRunEndDate").ej2_instances[0];
        
        // Show progress
        document.getElementById("reRunResultsContainer").style.display = "none";
        document.getElementById("reRunProgressContainer").style.display = "block";
        document.getElementById("reRunProgressMessage").textContent = "Generating report for " + this.selectedContacts.length + " contact(s)...";
        document.getElementById("btnReRunReportGenerate").disabled = true;
        
        var requestData = {
            ContactIds: this.selectedContacts,
            StartDate: startDatePicker.value.toISOString(),
            EndDate: endDatePicker.value.toISOString()
        };
        
        $.ajax({
            url: API_ENDPOINTS.REEXPORT_BATCH_REPORT,
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(requestData),
            success: function(response) {
                document.getElementById("reRunProgressContainer").style.display = "none";
                
                if (response.isError) {
                    alert("Error: " + response.message);
                    document.getElementById("reRunResultsContainer").style.display = "block";
                    reRunReport.updateSelectedCount();
                } else {
                    // Show download links
                    document.getElementById("reRunDownloadContainer").style.display = "block";
                    
                    if (response.filePathPDF) {
                        document.getElementById("reRunDownloadPDF").href = API_ENDPOINTS.DOWNLOAD_FILE + '?filePath=' + encodeURIComponent(response.filePathPDF) + '&fileName=' + encodeURIComponent(response.fileNamePDF || 'BatchReport.pdf');
                        document.getElementById("reRunDownloadPDF").style.display = "inline-block";
                    } else {
                        document.getElementById("reRunDownloadPDF").style.display = "none";
                    }
                    
                    if (response.filePathCSV) {
                        document.getElementById("reRunDownloadCSV").href = API_ENDPOINTS.DOWNLOAD_FILE + '?filePath=' + encodeURIComponent(response.filePathCSV) + '&fileName=' + encodeURIComponent(response.fileNameCSV || 'BatchReport.csv');
                        document.getElementById("reRunDownloadCSV").style.display = "inline-block";
                    } else {
                        document.getElementById("reRunDownloadCSV").style.display = "none";
                    }
                    
                    alert(response.message || "Report generated successfully!");
                }
            },
            error: function(error) {
                document.getElementById("reRunProgressContainer").style.display = "none";
                document.getElementById("reRunResultsContainer").style.display = "block";
                reRunReport.updateSelectedCount();
                console.error("Error generating report:", error);
                alert("Failed to generate report. Please try again.");
            }
        });
    }
};

/* =============================================================================
   EXPOSE TO WINDOW FOR RAZOR TEMPLATE COMPATIBILITY
   Syncfusion components reference operations.* in HTML attributes
   ============================================================================= */
window.operations = operations;
window.resendRemittances = resendRemittances;
window.reRunReport = reRunReport;
export default reRunReport;
window.reRunReport = reRunReport;
